module.exports = __webpack_public_path__ + "static/Apercu-Bold-77e5b314ff5b416b546c2fc46689e707.woff";